//登录

import { deleteRequest, downPostRequest, getRequest, postRequest, putRequest } from '@/config/request';
import { SYS_BASE_URL } from "@/constant/Const";

export const login = (data) => {
    return postRequest(SYS_BASE_URL + "/api/login/login", data);
}

export const logout = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/loginOut", data);
}

//获取路由
export const getRouteList = (data) => {
    return getRequest(SYS_BASE_URL + "/api/menu/tree", data);
}
//获取登录图形验证码
export const getloginimage = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/captcha", data, 'blob');
    // return getRequest(SYS_BASE_URL + "/api/login/image", data);
}